import { ModalFooter as FBModalFooter } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ModalFooter = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.modal.footer,
    className: `${props.className}`,
  };
  return <FBModalFooter {...tmpProps}>{props.children}</FBModalFooter>;
};

export default ModalFooter;